<div class="container  align-items-center">
    <!-- <div class="card card-container  "> -->

    <div class="">
        <div class="row">
            <h1 class="col-10 cardHeader card-title text-left"><strong>Voeg Onderneming Toe</strong></h1>

        </div>

        <div class=" row ">
            <div class="col-12">

                <form [formGroup]="ondernemingFormGroup" (ngSubmit)="onSubmit()">
                    <div class="form-row">

                        <div class="form-group col-md-6">
                            <label class="font-weight-bold" for="naam">Naam</label>
                            <input ng-valid formControlName="naam" type="text" name="naam"class="form-control" required>
                        </div>
                        <div class="form-group col-md-6">
                            <label class="font-weight-bold" for="kleur">Kleur</label>
                            <input ng-valid formControlName="kleur" type="text" name="kleur" class="form-control"  required>
                        </div>
                        <div class="form-group col-md-6">
                            <label class="font-weight-bold" for="kleurKnoppen">KleurKnoppen</label>
                            <input ng-valid formControlName="kleurKnoppen" type="text" name="kleurKnoppen" class="form-control" required>
                        </div>
                       
                    </div>
                    <div class="text-right">
                        <button type="submit" 
                        [disabled]="!ondernemingFormGroup.valid" class="btn btn-primary">VOEG TOE</button>
                      </div>
                </form>
            </div>
        </div>
    </div>
    <div class="">
        <div class="row">
            <h1 class="col-10 cardHeader card-title text-left"><strong>Delete Onderneming</strong></h1>

        </div>

        <div class=" row ">
            <div class="col-12">

                <form [formGroup]="deleteFormGroup" (ngSubmit)="delete()">
                    <div class="form-row">

                        <div class="form-group col-md-6">
                            <label class="font-weight-bold" for="id">id</label>
                            <input ng-valid formControlName="id" type="text" name="id"class="form-control" required>
                        </div>    
                    </div>
                    <div class="text-right">
                        <button type="submit" 
                        [disabled]="!deleteFormGroup.valid" class="btn btn-primary">DELETE</button>
                      </div>
                </form>
            </div>
        </div>
    </div>

    <div class="">
        <div class="row">
            <h1 class="col-10 cardHeader card-title text-left"><strong>Actieve ondernemingen</strong></h1>

        </div>

        <div class=" row ">
            <div class="col-12 " *ngIf="ondernemingen">

                <div  *ngFor= "let e of ondernemingen">
                   
                        <button [routerLink]="['/', e.naam,'tools']"  class="m-1 btn btn-primary">
                            {{e.naam}}
                        </button>
                    

                </div>
                <!-- <form [formGroup]="addUserFormGroup" (ngSubmit)="addUser()">
                    <div class="form-row">

                        <div class="form-group col-md-6">
                            <label class="font-weight-bold" for="id">email</label>
                            <input ng-valid formControlName="email" type="text" name="email"class="form-control" required>
                        </div>    
                        <div class="form-group col-md-6">
                            <label class="font-weight-bold" for="id">wachtwoord</label>
                            <input ng-valid formControlName="wachtwoord" type="text" name="wachtwoord"class="form-control" required>
                        </div>    
                        <div class="form-group col-md-6">
                            <label class="font-weight-bold" for="id">admin Van</label>
                            <input ng-valid formControlName="adminVan" type="text" name="adminVan"class="form-control" required>
                        </div>  
                    </div>
                    <div class="text-right">
                        <button type="submit" 
                        [disabled]="!addUserFormGroup.valid" class="btn btn-primary">VOEG TOE</button>
                      </div>
                </form> -->
            </div>
        </div>
    </div>

</div>